import React, { Component } from "react";
import { can } from "../../utils/permission";
import {
  company,
  loading,
  NavbarAdmin,
  Pagination,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  Modal,
  Select,
  format_date,
  activeOptions,
  t // นำเข้าฟังก์ชันแปลภาษา
} from "../../components/CustomComponent.js"; 
import ChecklistTreeEditor from "./checklist-templates/ChecklistTreeEditor.js";
import StatusPicker, { StatusPill, statusLabel } from "./checklist-templates/StatusPicker.js";
import {
  buildTree,
  cloneTree,
  countItems,
  findProblem,
  summarize,
  toPayload,
} from "./checklist-templates/checklistTree.js";

// ประเภทคำตอบของรายการตรวจ - ใช้แสดง badge ตอนดู (ตอนสร้าง/แก้ใช้ dropdown ใน ChecklistTreeEditor)
// check/yesno = Toggle (3 ตัวเลือก), checkbox = Toggle (2 ตัวเลือก), qty = จำนวน (ตัวเลขพร้อมหน่วย)
const getInputTypeLabel = (value) =>
  ({
    check: t("ct_type_toggle3"),
    yesno: t("ct_type_toggle3"),
    checkbox: t("ct_type_toggle2"),
    measurement: t("ct_type_measurement"),
    text: t("ct_type_text"),
    qty: t("ct_type_qty"),
  }[value] || value || "-");

// สถานะของเทมเพลตจาก response (เผื่อ response เก่าที่มีแต่ is_active)
const getTemplateStatus = (item) => item?.status || (item?.is_active === false ? "inactive" : "active");

// แสดงรายการในต้นไม้ (โหมดดู) พร้อมเลขลำดับ 1, 2, 2.1
const renderViewNodes = (list, prefix = "") => {
  let sec = 0;
  let idx = 0;
  return list.map((node) => {
    if (node.kind === "section") {
      sec += 1;
      const num = `${prefix}${sec}`;
      return (
        <div key={node.id}>
          <div className="d-flex align-items-center justify-content-between rounded-3 px-3 py-2 mb-2" style={{ background: "#e8efff", borderLeft: "4px solid #2563eb" }}>
            <div className="fw-bold text-dark text-14"><span className="text-primary me-2">{num}</span>{node.name}</div>
            <span className="text-secondary text-12">{countItems(node.children)} {t("items")}</span>
          </div>
          <div className="d-flex flex-column gap-2 mb-2" style={{ marginLeft: "14px", paddingLeft: "16px", borderLeft: "2px dashed #c5cedb" }}>
            {renderViewNodes(node.children, `${num}.`)}
          </div>
        </div>
      );
    }
    idx += 1;
    return (
      <div key={node.id} className="d-flex align-items-center justify-content-between bg-light rounded-3 p-3">
        <div className="d-flex align-items-center">
          <div className="wpx-25 hpx-25 rounded-circle bg-primary-light text-primary d-flex align-items-center justify-content-center fw-bold text-12 me-3 flex-shrink-0">
            {idx}
          </div>
          <div className="text-dark text-14">{node.description}</div>
        </div>
        <div className="ms-3 flex-shrink-0 d-flex align-items-center gap-2">
          {node.is_required && (
            <span className="badge bg-danger-light text-danger fw-bold px-2 py-1 text-11" style={{ backgroundColor: "#fdecec", color: "#e5484d" }}>
              {t("required_label")}
            </span>
          )}
          <span className="badge bg-primary-light text-primary fw-bold px-3 py-1 text-12">{getInputTypeLabel(node.input_type)}</span>
        </div>
      </div>
    );
  });
};

export default class ChecklistTemplates extends Component {
  constructor(props) {
    super(props);
    this.nameRef = React.createRef();
   this.state = {
      page: 1,
      page_size: 100000,
      uid: "",
      modal_create: false,
      modal_update: false,
      modal_view: false,
      filter_search: "",
      asset_group_id: "",

      template_name: "",
      category: "",
      description: "",
      // ต้นไม้ Section / รายการ (ดู checklist-templates/checklistTree.js) + สถานะเทมเพลต
      checklist_tree: [],
      status: "active",
      editor_key: 0,
      // ชื่อเทมเพลตต้นทางเมื่อกด Duplicate (ว่าง = ไม่ใช่โหมดสำเนา)
      dup_from: "",
      view_data: null,
      data_categories: [],
      tabs: [{ value: "", label: t("all_templates") }],

      data: []
    };
  }

  async componentDidMount() {
    this.Get(1);
  }

  normalizeArrayData = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (payload && typeof payload === "object") return [payload];
    return [];
  }

  Get = async (page) => {
    const { filter_search, page_size, asset_group_id } = this.state;
    loading(true);
    let [resultTemplates, resultCategories] = await Promise.all([
      GET("admin/checklist-templates", {
        page: page,
        page_size: page_size,
        data_search: filter_search || "",
        asset_group_id: asset_group_id || "",
        uid: ""
      }),
      GET("warehouse/part-categories", { page_size: 10000, page: 0 })
    ]);

    const templateData = resultTemplates?.status ? this.normalizeArrayData(resultTemplates.data) : [];
    const categoryOptions = resultCategories?.status
      ? this.normalizeArrayData(resultCategories.data).map((item) => ({ is_active: item.is_active, value: item.uid, label: item.name }))
      : [];
    const fallbackCategories = templateData
      .map((item) => ({
        value: item.asset_group?.uid || "",
        label: item.asset_group?.name || t("general")
      }))
      .filter((item) => item.value && item.label);
    const dataCategories = categoryOptions.length > 0
      ? categoryOptions
      : fallbackCategories.filter((item, index, self) => self.findIndex((entry) => entry.value === item.value) === index);
    const tabs = [
      ...dataCategories
    ];

    if (resultTemplates?.status || resultCategories?.status) {
      this.setState({
        data: templateData,
        data_categories: dataCategories,
        tabs,
        page: page
      });
    }
    loading(false);
  };

  handleSave = async () => {
    const { uid, template_name, category, description, checklist_tree, status } = this.state;
    if (!template_name) {
      alert("", "warning", t("warning"), t("please_enter_template_name"));
      return;
    }
    const problem = findProblem(checklist_tree);
    if (problem) {
      const reason =
        problem.type === "section_name"
          ? `${t("ct_err_section_name")} (Section ${problem.num})`
          : problem.type === "range"
            ? `${t("checklist_min_max_invalid")}: ${problem.node.description || "-"}`
            : `${t("ct_err_unit")}: ${problem.node.description || "-"}`;
      alert("", "warning", t("warning"), reason);
      return;
    }
    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);
      // sections + items ส่งคู่กันเสมอ = โครงสร้างทั้งชุด (เทมเพลตเดิมที่ไม่มี Section ได้ sections: [])
      const { sections, items } = toPayload(checklist_tree);
      const payload = {
        company_id: company?.id || "",
        asset_group_id: category,
        name: template_name,
        description: description,
        // backend sync is_active ให้เองจาก status (active = เปิดใช้งาน)
        status,
        sections,
        // POST/PUT ตัดค่า null ทิ้งก่อนส่ง (removeEmptyString) แต่ backend ถือ "ไม่ส่ง" = ไม่แก้ค่าเดิม
        // min/max ที่ล้างเป็น "ไม่กำหนด" จึงต้องส่ง null จริง - NaN ผ่านตัวกรองและ JSON.stringify แปลงเป็น null
        items: items.map((item) => ({ ...item, min: item.min === null ? NaN : item.min, max: item.max === null ? NaN : item.max })),
      };

      let result = !uid
        ? await POST("admin/checklist-templates", payload)
        : await PUT("admin/checklist-templates/" + uid, payload);

      if (result?.status === true) {
        alert("#", "success", t("success"), t("save_success"));
        this.setState({ modal_create: false, modal_update: false });
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  handleDelete = async (id) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      let result = await DELETE("admin/checklist-templates/" + id, null);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  openCreateModal = () => {
    this.setState((state) => ({
      modal_create: true, modal_update: false, modal_view: false,
      uid: "", template_name: "", category: "", description: "", dup_from: "",
      status: "active",
      // สร้างใหม่เริ่มเป็นรายการว่าง (ผู้ใช้กด + Add Section / + Add Item เอง)
      checklist_tree: [],
      editor_key: state.editor_key + 1,
    }));
  }

  openEditModal = (item) => {
    this.setState((state) => ({
      modal_create: false, modal_update: true, modal_view: false,
      uid: item.uid, dup_from: "",
      template_name: item.name, category: item.asset_group?.uid || "", description: item.description,
      // เทมเพลตเดิมที่ยังไม่มี status ถือว่าใช้งาน (ตามค่า is_active เดิม)
      status: getTemplateStatus(item),
      checklist_tree: buildTree(item.sections, item.items),
      editor_key: state.editor_key + 1,
    }));
  }

  // สร้างชื่อสำเนา (ไม่เกิน 200 ตัวอักษร ตาม maxLength ของช่องชื่อ)
  makeCopyName = (name) => {
    const src = (name || "").trim() || t("ct_dup_no_name");
    const suffix = ` ${t("ct_dup_suffix")}`;
    return { src, name: src.slice(0, Math.max(0, 200 - suffix.length)) + suffix };
  }

  focusName = () => {
    const input = this.nameRef.current;
    if (input) {
      input.focus({ preventScroll: true });
      input.select();
    }
  }

  // Duplicate จากหน้าแก้: ไม่มี uid -> Save ไปทาง POST ต้นฉบับไม่ถูกแตะ
  // editor_key เปลี่ยน = ต้นไม้ remount จึงออกจากโหมดย้ายตำแหน่งให้เอง
  handleDuplicate = () => {
    const copy = this.makeCopyName(this.state.template_name);
    this.setState(
      (state) => ({
        modal_create: true, modal_update: false,
        uid: "", dup_from: copy.src, template_name: copy.name,
        status: "draft",
        checklist_tree: cloneTree(state.checklist_tree),
        editor_key: state.editor_key + 1,
      }),
      this.focusName
    );
  }

  // Duplicate จากหน้าดู: สร้างสำเนาจาก view_data เปิดฟอร์มสร้างใหม่ (Draft)
  handleDuplicateFromView = () => {
    const { view_data } = this.state;
    if (!view_data) return;
    const copy = this.makeCopyName(view_data.name);
    this.setState(
      (state) => ({
        modal_view: false, modal_create: true, modal_update: false,
        uid: "", dup_from: copy.src, template_name: copy.name,
        category: view_data.asset_group?.uid || "",
        description: view_data.description || "",
        status: "draft",
        checklist_tree: cloneTree(buildTree(view_data.sections, view_data.items)),
        editor_key: state.editor_key + 1,
      }),
      this.focusName
    );
  }

  openViewModal = (item) => {
    this.setState({
      modal_view: true,
      modal_create: false,
      modal_update: false,
      view_data: item
    });
  }

  getCategoryLabel = (item) => {
    const categoryId = item?.asset_group?.uid || "";
    return this.state.data_categories.find((category) => category.value === categoryId)?.label
      || item?.asset_group?.name
      || t("general");
  }

  render() {
   const {
      modal_create, modal_update, modal_view, filter_search, asset_group_id, tabs, data,
      template_name, category, description, checklist_tree, view_data, data_categories, status, editor_key, dup_from
    } = this.state;
    const filteredData = data;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("checklist_templates")}</h3>
                        <div className="text-secondary text-14">{t("checklist_desc")}</div>
                    </div>
                </div>

                <div className="row g-3 mb-4">
                    <div className="col-lg-3 col-md-6">
                        <div className="card border border-primary rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #0d6efd !important" }}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="text-secondary text-14 mb-1">{t("total_templates")}</div>
                                    <h2 className="fw-bold mb-0 text-dark">{filteredData.length || 0}</h2>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf46c"}</div>
                            </div>
                        </div>
                    </div>
                    {/* KPI อื่นๆ ใช้โครงสร้างเดียวกัน */}
                    <div className="col-lg-3 col-md-6">
                        <div className="card border border-success rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #198754 !important" }}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="text-secondary text-14 mb-1">{t("active")}</div>
                                    <h2 className="fw-bold mb-0 text-success">{filteredData.filter((e) => getTemplateStatus(e) === "active")?.length || 0}</h2>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf058"}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="card border border-secondary rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #ffc107 !important" }}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="text-secondary text-14 mb-1">{t("inactive")}</div>
                                    <h2 className="fw-bold mb-0 text-warning">{filteredData.filter((e) => getTemplateStatus(e) === "inactive")?.length || 0}</h2>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{"\uf06a"}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="card border border-secondary rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="text-secondary text-14 mb-1">{t("draft")}</div>
                                    <h2 className="fw-bold mb-0 text-secondary">{filteredData.filter((e) => getTemplateStatus(e) === "draft")?.length || 0}</h2>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-light text-secondary d-flex align-items-center justify-content-center text-20 icon">{"\uf044"}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                        <div className="d-flex flex-wrap gap-2 flex-grow-1">
                            <div className="position-relative">
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-350"
                                    style={{ height: "38px" }}
                                    placeholder={t("search")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                                />
                            </div>
                            <Select
                                className="form-control wpx-280"
                                options={tabs}
                                value={asset_group_id}
                                onChange={(e) => this.setState({ asset_group_id: e || "" })}
                                placeholder={t("all_templates")}
                            />
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() => this.setState({ filter_search: "", asset_group_id: "" }, () => this.Get(1))}
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        {can("checklist-templates.create") && (
                          <button className="btn btn-primary fw-bold px-3 py-2 rounded-3 shadow-sm d-flex align-items-center" onClick={this.openCreateModal}>
                              <span className="me-2">+</span> {t("new_template")}
                          </button>
                        )}
                    </div>
                </div>

                <div className="row g-3">
                    {filteredData.map((item, idx) => (
                        <div key={idx} className="col-lg-4 col-md-4">
                            <div className="card border-0 rounded-4 shadow-sm p-4 h-100 bg-white">
                                <div className="pointer" onClick={() => this.openViewModal(item)}>
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <span
                                            className={`badge rounded-2 px-2 py-1 text-10 fw-bold bg-${item.asset_group?.uid ? "primary" : "secondary"}-light text-${
                                                item.asset_group?.uid ? "primary" : "secondary"
                                            }`}
                                        >
                                            {this.getCategoryLabel(item)}
                                        </span>
                                        <StatusPill status={getTemplateStatus(item)} />
                                    </div>

                                    <h5 className="fw-bold text-dark mb-2 text-truncate">{item.name}</h5>
                                    <div
                                        className="text-secondary text-12 mb-2"
                                        style={{ height: "36px", overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}
                                    >
                                        {item.description}
                                    </div>

                                    <div className="d-flex justify-content-between text-secondary text-12 mb-3">
                                        <div className="d-flex align-items-center fw-bold text-primary">
                                            <span className="icon me-2">{"\uf0ca"}</span> {item.items?.length || 0} {t("items")}{item.sections?.length > 0 && ` · ${item.sections.length} Section`}
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <span className="icon me-2">{"\uf012"}</span> {t("used")} {item.usage_count || 0} {t("times")}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="text-secondary text-10">
                                        {t("last_used")}: {item.updated_at ? format_date(item.updated_at.split("T")[0], "dd/mm/yyyy", "th") : "-"}
                                    </div>
                                    <div className="d-flex gap-2 text-16">
                                        {can("checklist-templates.update") && (
                                          <span
                                              className="icon text-secondary pointer hover-primary transition-hover"
                                              onClick={(e) => {
                                                  e.stopPropagation();
                                                  this.openEditModal(item);
                                              }}
                                          >
                                              {"\uf044"}
                                          </span>
                                        )}
                                        {can("checklist-templates.delete") && (
                                          <span
                                              className="icon text-secondary pointer hover-danger transition-hover"
                                              onClick={(e) => {
                                                  e.stopPropagation();
                                                  this.handleDelete(item.uid);
                                              }}
                                          >
                                              {"\uf2ed"}
                                          </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Pagination */}
                {/* <div className="d-flex justify-content-between align-items-center mt-4">
                  <div className="text-secondary text-12">
                    {t("showing")} 1-{filteredData.length} {t("of")} {count} {t("items")}
                  </div>
                  <Pagination
                    count={Math.ceil(count / this.state.page_size) || 1}
                    page={this.state.page}
                    onChange={(_, p) => this.Get(p)}
                    showFirstButton={false} showLastButton={false}
                  />
                </div> */}
            </div>

            {/* MODAL: VIEW */}
            <Modal size="md" show={modal_view} onHide={() => this.setState({ modal_view: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
                <Modal.Header className="border-bottom px-4 py-3 bg-white" closeButton>
                    <div className="w-100 pe-4">
                        <span className={`badge bg-primary-light text-primary rounded-pill px-3 py-1 mb-2 me-2 fw-bold text-12`}>{this.getCategoryLabel(view_data)}</span>
                        {view_data && <StatusPill status={getTemplateStatus(view_data)} />}
                        <h4 className="fw-bold mb-1 text-dark">{view_data?.name || t("template_title")}</h4>
                        <div className="text-secondary text-14">{view_data?.description}</div>
                    </div>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white" style={{ maxHeight: "65vh", overflowY: "auto" }}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="fw-bold text-dark d-flex align-items-center m-0">
                            <span className="icon text-primary me-2">{"\uf0ca"}</span> {t("checklist_items")}
                        </h6>
                        <span className="text-secondary fw-bold text-14">
                            {view_data?.items?.length || 0} {t("items")}
                        </span>
                    </div>
                    <div className="d-flex flex-column gap-2">
                        {view_data && renderViewNodes(buildTree(view_data.sections, view_data.items))}
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-between align-items-center">
                    {can("checklist-templates.create") && (
                      <button className="btn btn-white border px-3 py-2 text-dark rounded-3 fw-medium" title={t("ct_dup_title")} onClick={this.handleDuplicateFromView}>
                          {t("ct_dup_btn")}
                      </button>
                    )}
                    <div className="d-flex gap-2">
                        <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold shadow-sm" onClick={() => this.setState({ modal_view: false })}>
                            {t("close")}
                        </button>
                        {can("checklist-templates.update") && (
                          <button className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm" onClick={() => this.openEditModal(view_data)}>
                              <span className="icon me-2">{"\uf044"}</span> {t("edit")}
                          </button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>

            {/* MODAL: CREATE & EDIT */}
            <Modal
                size="xl"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
            >
                <Modal.Header className="border-0 px-4 py-3" style={{ backgroundColor: "#2563eb" }}>
                    <div className="text-white">
                        <h4 className="fw-bold mb-1 text-white">{t("create_new_template")}<span className="ct-stbadge">{statusLabel(status)}</span></h4>
                        <div className="text-white-50 text-14" style={{ color: "#bfdbfe" }}>
                            {dup_from ? `${t("ct_dup_from")} “${dup_from}”` : t("create_template_desc")}
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn-close btn-close-white"
                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", borderRadius: "8px", padding: "0.6rem" }}
                        onClick={() => this.setState({ modal_create: false, modal_update: false })}
                    ></button>
                </Modal.Header>

                <Modal.Body className="p-4 bg-white">
                    {dup_from && (
                        <div
                            role="status"
                            className="mb-3 px-3 py-2 text-13"
                            style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderLeft: "4px solid #2563eb", borderRadius: 8, color: "#1e3a8a" }}
                        >
                            {t("ct_dup_note_prefix")} “{dup_from}” {t("ct_dup_note_suffix")}
                        </div>
                    )}
                    <div className="row g-3 mb-4 pb-4">
                        <div className="col-md-6 col-lg-4">
                            <label className="form-label text-14 fw-bold text-dark">
                                {t("template_name_label")} <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control py-2 text-dark"
                                placeholder={t("template_name_placeholder")}
                                ref={this.nameRef}
                                maxLength={200}
                                value={template_name}
                                onChange={(e) => this.setState({ template_name: e.target.value })}
                            />
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <label className="form-label text-14 fw-bold text-dark">
                                {t("machine_asset_group")} <span className="text-danger">*</span>
                            </label>
                            <Select
                                className="form-control w-100"
                                options={activeOptions(data_categories, category)}
                                value={category}
                                onChange={(e) => this.setState({ category: e })}
                                placeholder={t("select_machine_asset_group_placeholder")}
                            />
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <StatusPicker value={status} onChange={(next) => this.setState({ status: next })} />
                        </div>
                        <div className="col-12 mt-3">
                            <label className="form-label text-14 fw-bold text-dark">{t("description")}</label>
                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder={t("checklist_description_placeholder")}
                                value={description}
                                onChange={(e) => this.setState({ description: e.target.value })}
                            ></textarea>
                        </div>
                    </div>

                    <div>
                        <ChecklistTreeEditor
                            key={editor_key}
                            tree={checklist_tree}
                            onChange={(next) => this.setState({ checklist_tree: next })}
                        />

                        <div className="alert d-flex align-items-start gap-3 p-3 rounded-3 mb-0" style={{ backgroundColor: "#eff6ff", border: "1px solid #bfdbfe" }}>
                            <span style={{ fontSize: "1.2rem", lineHeight: 1 }}>💡</span>
                            <div style={{ color: "#1e3a8a", fontSize: "14px" }}>
                                <div>
                                    <strong>{t("note")}:</strong> {t("checklist_measurement_note_prefix")} <strong>{t("measurement_type")}</strong> {t("checklist_measurement_note_middle")} <strong>Min/Max</strong> {t("checklist_measurement_note_suffix")}
                                </div>
                                <div>
                                    {t("checklist_required_note_prefix")} <strong>{t("required_label")}</strong> {t("checklist_required_note_suffix")}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-between align-items-center gap-2 flex-wrap">
                    <div className="d-flex align-items-center gap-3 flex-wrap">
                        {modal_update && can("checklist-templates.create") && (
                            <button type="button" className="btn btn-white border px-3 py-2 text-dark rounded-3 fw-medium" title={t("ct_dup_title")} onClick={this.handleDuplicate}>
                                {t("ct_dup_btn")}
                            </button>
                        )}
                        {(() => {
                            const sum = summarize(checklist_tree);
                            return (
                                <span className="text-secondary text-13">
                                    {sum.sections} Section · {sum.items} {t("items")} · {t("checklist_required_summary")} {sum.required} · {t("checklist_optional_summary")} {sum.optional}
                                </span>
                            );
                        })()}
                    </div>
                    <div className="d-flex gap-2">
                        <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-medium" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                            {t("cancel")}
                        </button>
                        <button
                            onClick={this.handleSave}
                            className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm"
                            style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        >
                            <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
